/* ==========================================================================
   Gild & Ink — global shortlist store.
   Loaded from sections/gi-header.liquid on EVERY page (not just the
   Collection/Ranges redesign pages) so the header's shortlist icon and
   count always reflect gi-shortlist in localStorage, wherever the visitor
   is. assets/gi-collections-shared.js (loaded only on the two redesigned
   pages) reuses window.GiShortlist rather than creating its own, so both
   places share one live store and one set of change listeners.

   Item shape: { id, range, piece, label, handle, variantId }. `handle` is
   used here to link out to the product page from the header panel.
   ========================================================================== */
(function () {
  'use strict';
  if (window.GiShortlist) return; // already initialised (unlikely, but don't clobber)

  var KEY = 'gi-shortlist';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var val = raw ? JSON.parse(raw) : [];
      return Array.isArray(val) ? val : [];
    } catch (e) {
      return [];
    }
  }
  function write(arr) {
    try { window.localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) { /* ignore */ }
  }

  var listeners = [];
  var items = read();

  function persist() { write(items); listeners.forEach(function (fn) { fn(items); }); }

  window.GiShortlist = {
    all: function () { return items.slice(); },
    has: function (id) { return items.some(function (i) { return i.id === id; }); },
    get: function (id) { return items.find(function (i) { return i.id === id; }); },
    add: function (item) {
      if (this.has(item.id)) return;
      items.push(item);
      persist();
    },
    remove: function (id) {
      items = items.filter(function (i) { return i.id !== id; });
      persist();
    },
    toggle: function (item) {
      if (this.has(item.id)) { this.remove(item.id); return false; }
      this.add(item);
      return true;
    },
    clear: function () { items = []; persist(); },
    onChange: function (fn) { listeners.push(fn); }
  };
})();
